<script context="module">
    import {get} from "svelte/store";
    import {componentName} from "./stores/store";

    export const bxSubmitReview = (formData) => {
        return new Promise((resolve) => {
            BX.ajax.runComponentAction(get(componentName), 'submitReview', {
                mode: 'class',
                data: formData,
            }).then(response => {
                if (response.status === 'success') {
                    resolve({success: true, data: response.data});
                } else {
                    const errMsg = response.errors?.[0]?.message || 'Ошибка при отправке. Попробуйте ещё раз.';
                    resolve({success: false, error: errMsg});
                }
            }).catch(err => {
                console.error('[review form] submit error:', err);
                const errMsg = err?.errors?.[0]?.message || 'Не удалось отправить. Попробуйте ещё раз.';
                resolve({success: false, error: errMsg});
            });
        });
    };
</script>
